import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-fund-list-item',
  templateUrl: './fund-list-item.component.html',
  styleUrls: ['./fund-list-item.component.scss']
})
export class FundListItemComponent implements OnInit {


  @Input()
  type = ''

  @Input()
  riskLevel = '1'

  @Input()
  title = ''

  @Input()
  description = ''

  @Input()
  fundid = ''

  @Input()
  Currency = ''

  @Input()
  recommended = false

  constructor() { }

  ngOnInit() {

  }

}
